import React, { useEffect } from "react";
import NameSection from "./NameSection";
import UrlSection from "./UrlSection";
import AddressSection from "./AddressSection";
import DeliverySection from "./DeliverySection";
import CollectionSection from "./CollectionSection";
import ColorSection from "./ColorSection";
import LoginSection from "./LoginSection";
import LogoSection from "./LogoSection";
import SummarySection from "./SummarySection";
import { useState } from "react";
import { CSSTransition } from "react-transition-group";

export function asFormSection(Section, config) {

	const {
		title,
		nextButtonText = <>
			<span>Next</span> <span>&#10132;</span>
		</>,
		backButtonText = <>
			<span style={{ transform: "scaleX(-1)", display: "inline-block" }}>&#10132;</span> <span>Back</span>
		</>,
	} = config;

	// Create the form section.
	return function FormSection(props) {

		const {
			number,
			error,
			onNext,
			onBack,
			onComplete,
			buttons,
		} = props;

		const [showError, setShowError] = useState(false);
		const [lastError, setLastError] = useState(error);

		useEffect(() => {
			if (error && error !== lastError) setLastError(error);
		}, [error, lastError]);

		return <div className="form-section">
			<div className="inner">
				<h5 className="number d-none d-tablet-block">{number}</h5>
				{title && <h2><span className="number-small d-inline-block d-tablet-none">{number}</span>{title}</h2>}
				<div className="content">
					<Section
						{...config}
						{...props}
					/>
				</div>
				{buttons ? buttons(props) : <div className="buttons">
					{Boolean(onBack) && <button
						className="v-middle"
						style={{
							backgroundColor: "#191717"
						}}
						onClick={e => {
							onBack();
						}}
					>{backButtonText}</button>}
					{Boolean(onNext) && <button
						className={`v-middle ${Boolean(error) ? "disabled" : ""}`}
						onMouseEnter={e => {
							if (error && !showError) setShowError(true);
						}}
						onClick={e => {
							if (!error) {
								onNext();
							} else if (!showError) {
								setShowError(true);
							}
						}}
					>{nextButtonText}</button>}
					{Boolean(onComplete) && <button
						className="v-middle complete"
						disabled={Boolean(error)}
						onClick={e => {
							if (!error) onComplete();
						}}
					><span>Continue</span> <span>&#10132;</span></button>}
				</div>}
				<CSSTransition 
					classNames="pop" 
					in={Boolean(error && showError)} 
					timeout={500}
					
				>
					<div className="error poppable">
						{lastError}
					</div>
				</CSSTransition>
			</div>

		</div>
	}
}

export default [
	// Logging in.
	{
		slug: "login",
		Component: asFormSection(LoginSection, {
			slug: "login",
			title: "Who are you?"
		}),
		// buttons: () => null,
		validate: ({ values }) => {
			if (!values.userData) {
				return "You have to log in or create an account."
			} else if (values.userData.shop) {
				return "You already have a shop. You can't have more than one... For now."
			} else {
				return true;
			}
		}
	},
	// The name of the shop
	{
		slug: "name",
		validate: ({ values }) => {
			if (!values.name) {
				return "All shops need a name..";
			} else {
				return true;
			}
		},
		Component: asFormSection(NameSection, {
			slug: "name",
			title: "Shop Name",
		})
	},
	// The shop's slug.
	{
		slug: "slug",
		validate: ({ values }) => {
			if (!values.slug) {
				return "You have to have a URL.";
			} else {
				return true;
			}
		},
		Component: asFormSection(UrlSection, {
			slug: "slug",
			title: "Shop URL",
		})
	},
	// Shop's geographic address.
	{
		slug: "address",
		validate: ({ values }) => {
			if (!values.address) {
				return "You have to set an address.";
			} else if (!values.address.line1) {
				return "The first line of the address is required."
			} else if (!values.address.town) {
				return "Town is required."
			} else if (!values.address.postCode) {
				return "You have to give a postcode."
			} else {
				return true;
			}
		},
		Component: asFormSection(AddressSection, {
			slug: "address",
			title: "Shop's Address",
		})
	},
	// Delivery settings.
	{
		slug: "delivery",
		validate: ({ values }) => {
			if (typeof values.acceptDelivery !== "boolean") {
				return "You have to pick either yes or no."
			} else if (values.acceptDelivery && (!values.deliveryTimes || !values.deliveryTimes.length)) {
				return "You have to have at least one delivery slot available."
			} else {
				return true;
			}
		},
		Component: asFormSection(DeliverySection, {
			slug: "delivery",
			title: "Delivery",
		})
	},
	// Collection settings.
	{
		slug: "collection",
		validate: ({ values }) => {
			if (typeof values.acceptCollection !== "boolean") {
				return "You have to pick either yes or no."
			} else if (values.acceptCollection && (!values.collectionTimes || !values.collectionTimes.length)) {
				return "You have to have at least one collection slot available."
			} else if (!values.acceptCollection && !values.acceptDelivery) {
				return "You've already said you don't accept delivery. You must accept at least one order type.";
			} else {
				return true;
			}
		},
		Component: asFormSection(CollectionSection, {
			slug: "collection",
			title: "Collection",
		})
	},
	// Logo settings
	{
		slug: "logo",
		Component: asFormSection(LogoSection, {
			slug: "logo",
			title: "Logo",
		})
	},
	// Color settings
	{
		slug: "colors",
		Component: asFormSection(ColorSection, {
			slug: "colors",
			title: "Brand Colours",
		})
	},
	// Summary
	{
		slug: "summary",
		Component: asFormSection(SummarySection, {
			slug: "summary",
			title: "Nearly Done",
		})
	},
];